import React, {Component} from 'react';

class NoRecordComponent extends Component {

	constructor(props) {
		super(props);

		this.state = {
			contract: "Müşteriye ait aktif sözleşme bulunamadı.",
			branch: "Müşteriye ait şube kaydı yoktur.",
			bank: "Kayıtlı banka hesap bilgisi yoktur.",
			prefix: "Bu belge türüne ait ön ek tanımlanmamıştır."
		}
	}

	render() {
		return (
			<div className="row col-12">
                <div className="col-md-12">
                    {this.props.section === 'branch' && this.state.branch}
                    {this.props.section === 'prefix' && this.state.prefix}
                </div>
            </div>
		)
	}
}

export default NoRecordComponent;